import { api } from './client';

/**
 * EFICIENCIA (portado de Tony Boga, 4-nov-2026). Prefijo: /api/eficiencia.
 * Solo ADMIN: son números de plata y de desempeño de la gente.
 */

export interface FilaDeEficiencia {
  clave: string;
  nombre: string;
  chats: number;
  pasaron: number;
  compraron: number;
  noCompraron: number;
  pendientes: number;
  /** Pendientes con «volver a escribirle» ya vencido. */
  vencidos: number;
  ventas: number;
  vendido: number;
  /** compraron / pasaron, en %. `null` si nadie pasó. */
  tasaDeCierre: number | null;
  costo: number | null;
  costoPorChat: number | null;
  costoPorVenta: number | null;
  /** vendido / costo, en veces (2.5 = por cada peso, dos y medio). */
  retorno: number | null;
}

export interface Eficiencia {
  periodo: { desde: string; hasta: string };
  total: FilaDeEficiencia;
  porAnuncio: FilaDeEficiencia[];
  porVendedor: FilaDeEficiencia[];
}

export const getEficiencia = (dias: number) => {
  const hasta = new Date();
  const desde = new Date(hasta.getTime() - dias * 86400_000);
  return api.get<Eficiencia>(
    `/api/eficiencia?desde=${desde.toISOString()}&hasta=${hasta.toISOString()}`,
  );
};

export const ponerCostoDeAnuncio = (datos: { sourceId: string; titulo?: string; costo: number }) =>
  api.put<{ sourceId: string; titulo: string | null; costo: number }>(
    '/api/eficiencia/costo-anuncio',
    datos,
  );
